import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { spaceL, spaceS, spaceM, xdlColorText } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';
import { Column } from '@xing-com/xing-grid';

const LETTER_HEADLINE_HEIGHT = '66px';

export const StyledColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  padding-block: ${spaceL};
`;

export const StyledHeadline = styled(Headline)<{
  $isLetter: boolean;
}>`
  display: flex;
  align-items: flex-end;
  margin-bottom: ${spaceS};
  height: ${LETTER_HEADLINE_HEIGHT};

  font-size: ${({ $isLetter }) => ($isLetter ? '60px' : '24px')};
  line-height: ${({ $isLetter }) =>
    $isLetter ? LETTER_HEADLINE_HEIGHT : '30px'};
  ${({ $isLetter }) => ($isLetter ? 'text-transform: capitalize;' : '')};

  & a {
    color: ${xdlColorText};

    &:hover {
      text-decoration: none;
    }
  }
`;

export const NamesContainer = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
`;

export const HelperText = styled.span`
  font-weight: bold;
`;

export const StyledButton = styled.a`
  display: inline;
  color: ${xdlColorText};

  &::after {
    content: ', ';
  }

  &:last-child {
    &::after {
      content: '';
    }
  }
`;

export const StyledTextButton = styled(TextButton)`
  justify-content: flex-start;
  margin-top: ${spaceM};
  padding: 0;
  color: ${xdlColorText};
`;
